import Sidebar from "@/components/Sidebar";
import IdleTimeout from "@/components/IdleTimeout";

export default function AppLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 overflow-x-hidden pt-14 md:pt-0">
        <div className="max-w-[1600px] mx-auto p-4 sm:p-6 md:p-8">
          {children}
        </div>
      </main>
      <IdleTimeout />
    </div>
  );
}
